(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2step_cutom_popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const popupWrapper = document.getElementById('customPopupWrapper');
    if (!popupWrapper) return;

    const closeButton = document.getElementById('popupCloseButton');
    const backButton = document.getElementById('popupBackButton');
    const step1 = document.getElementById('popup-step-1');
    const step2 = document.getElementById('popup-step-2');
    const cards = popupWrapper.querySelectorAll('.popup-card');
    const step2ContentBlocks = popupWrapper.querySelectorAll('.popup-step-2-block-content');
    const triggerButton = document.getElementById('customPopupTriggerButton');
    const continueButton = document.getElementById('popupContinueButton');
    const cancelButton = document.getElementById('popupCancelButton');
    const popupOverlay = document.getElementById('popupOverlay');

    let selectedBlockId = null;
    
    const showPopup = () => popupWrapper.classList.add('is-visible');
    const hidePopup = () => {
      popupWrapper.classList.remove('is-visible');
      setTimeout(() => {
        if (step1) step1.style.display = 'block';
        if (step2) step2.style.display = 'none';
        step2ContentBlocks.forEach(content => content.style.display = 'none');
        selectedBlockId = null;
        cards.forEach(c => c.classList.remove('selected'));
        if (continueButton) continueButton.disabled = true;
      }, 300);
    };
    
    if (triggerButton) triggerButton.addEventListener('click', showPopup);
    if (closeButton) closeButton.addEventListener('click', hidePopup);
    if (cancelButton) cancelButton.addEventListener('click', hidePopup);
    if (popupOverlay) popupOverlay.addEventListener('click', hidePopup);

    cards.forEach(card => {
      card.addEventListener('click', () => {
        cards.forEach(c => c.classList.remove('selected'));
        card.classList.add('selected');
        selectedBlockId = card.getAttribute('data-block-id');
        if (continueButton) continueButton.disabled = false;
      });
    });

    if (continueButton) {
      continueButton.addEventListener('click', () => {
        if (!selectedBlockId) return;

        step2ContentBlocks.forEach(content => content.style.display = 'none');
        const contentToShow = document.getElementById(`content-display-${selectedBlockId}`);
        
        if (contentToShow) {
          console.log('DEBUG: Found content to show. HTML:', contentToShow.innerHTML);
          contentToShow.style.display = 'block';

          const scripts = Array.from(contentToShow.querySelectorAll('script'));
          console.log(`DEBUG: Found ${scripts.length} script(s) to execute.`);

          scripts.forEach((oldScript, index) => {
            console.log(`DEBUG: Executing script ${index + 1}...`);
            const newScript = document.createElement('script');
            
            Array.from(oldScript.attributes).forEach(attr => {
              newScript.setAttribute(attr.name, attr.value);
            });
            
            newScript.innerHTML = oldScript.innerHTML;
            
            // This handles scripts with a 'src' attribute
            if (oldScript.src) {
              newScript.src = oldScript.src;
            }

            if (oldScript.parentNode) {
              oldScript.parentNode.replaceChild(newScript, oldScript);
            } else {
               console.error('DEBUG: Script parent node not found, cannot execute.');
            }
          });

          if (step1) step1.style.display = 'none';
          if (step2) step2.style.display = 'block';
        } else {
          console.error(`DEBUG: Pop-up Error: Could not find content display for block ID: ${selectedBlockId}`);
        }
      });
    }

    if (backButton) {
      backButton.addEventListener('click', () => {
        if (step2) step2.style.display = 'none';
        if (step1) step1.style.display = 'block';
        step2ContentBlocks.forEach(content => content.style.display = 'none');
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popupWrapper.classList.contains('is-visible')) {
        hidePopup();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["New2step_custom_popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded",function(){
  const popup=document.getElementById("customPopupWrapper");
  const openBtn=document.getElementById("customPopupTriggerButton");
  const closeBtn=document.getElementById("popupCloseButton");
  const cancelBtn=document.getElementById("popupCancelButton");
  const overlay=document.getElementById("popupOverlay");
  const continueBtn=document.getElementById("popupContinueButton");
  const backBtn=document.getElementById("popupBackButton");
  const step1=document.getElementById("popup-step-1");
  const step2=document.getElementById("popup-step-2");
  const cards=popup.querySelectorAll(".popup-card");
  const contents=popup.querySelectorAll(".popup-step-2-block-content");
  let selected=null;

  const showPopup=()=>popup.classList.add("is-visible");
  const hidePopup=()=>popup.classList.remove("is-visible");

  if(openBtn) openBtn.onclick=showPopup;
  [closeBtn,cancelBtn,overlay].forEach(btn=>btn&&btn.addEventListener("click",hidePopup));

  cards.forEach(card=>{
    card.onclick=()=>{
      cards.forEach(c=>c.classList.remove("selected"));
      card.classList.add("selected");
      selected=card.dataset.blockId;
      continueBtn.disabled=false;
    };
  });

  continueBtn.onclick=()=>{
    if(!selected) return;
    step1.style.display="none";
    step2.style.display="block";
    contents.forEach(c=>c.style.display="none");
    const show=document.getElementById("content-display-"+selected);
    if(show){
      show.style.display="block";
      show.querySelectorAll("script").forEach(old=>{
        const s=document.createElement("script");
        s.innerHTML=old.innerHTML;
        old.parentNode.replaceChild(s,old);
      });
    }
  };

  backBtn.onclick=()=>{
    step2.style.display="none";
    step1.style.display="block";
    contents.forEach(c=>c.style.display="none");
    continueBtn.disabled=true;
    cards.forEach(c=>c.classList.remove("selected"));
  };

  document.addEventListener("keydown",e=>{
    if(e.key==="Escape") hidePopup();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
